// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-fe7e6b97fac7baf5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"b6249644cba9a008","2937":"fdf44e97d15cf041"}[chunkId] + ".js";
};